import BaseInputTimePicker from "./BaseInputTimePicker.vue";

export default BaseInputTimePicker;
